'use strict'

import ElementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'
import HashManager from 'assets/core/js/module/hashManager'
import PartialsManager from 'assets/core/js/module/partialsManager'
import budgetSlider from 'assets/core/js/page/product/budgetSlider'
import events from 'assets/themes/campings/js/page/product/search/events'
import partialEvents from 'assets/themes/campings/js/page/product/search/partialEvents'
import productCalendar from 'assets/themes/campings/js/page/product/productCalendar'
import recap from 'assets/themes/campings/js/page/product/search/recap'
import travelerSelector from 'assets/themes/campings/js/page/product/search/travelerSelector'
import { Facets } from 'assets/themes/campings/js/page/product/facets'
import { PartialsLoadingEvents } from 'assets/themes/campings/js/module/partials'
import { getCapacity, setCapacity } from 'assets/core/js/page/product/search/utils/capacity'
import { getNights, setNights } from 'assets/core/js/page/product/search/utils/night'
import { setDate } from 'assets/core/js/page/product/search/utils/date'
import { toggleAccommodations } from 'assets/themes/campings/js/page/product/results'

import type { Calendar as SearchCalendarType } from '@ui/Search/Calendar/component'

const updatePartials = function (): void {
  const calendar = ElementPropertiesManager.getProperty<SearchCalendarType>(document.getElementById('checkInDate') as HTMLInputElement, 'calendar')
  const parameters: Record<string, string> = {
    night: getNights(),
    capacity: getCapacity(),
    checkInDate: calendar?.input.value as string,
  }

  if (parameters.checkInDate === '') {
    delete parameters.checkInDate
  }

  if (parameters.night === '') {
    delete parameters.night
  }

  if (Object.entries(HashManager.getParameters()).sort().toString() !== Object.entries(parameters).sort().toString()) {
    PartialsManager.update('product', parameters)
    HashManager.setParameters(parameters, true)
  }
}

const clickViewMoreAccommodationsButton = (partialEl: HTMLElement, anchor: string): void => {
  const accommodationCardEl = document.getElementById(anchor)

  if (!accommodationCardEl) {
    return
  }

  if (!accommodationCardEl.closest('.results__list')?.hasAttribute('hidden')) {
    return
  }

  const viewMoreAccommodationsButtonEl = partialEl.querySelector<HTMLButtonElement>('button[data-additional-accommodations]')

  if (!viewMoreAccommodationsButtonEl) {
    return
  }

  const target = viewMoreAccommodationsButtonEl.getAttribute('data-additional-accommodations')

  target && toggleAccommodations(target)
}

const scrollToAccommodation = function (): void {
  const partialEl = document.querySelector<HTMLElement>('[data-partial-id="results"]')
  const anchor = HashManager.getAnchor()

  if (!partialEl || !anchor) {
    return
  }

  if (Object.keys(HashManager.getParameters()).length === 0) {
    clickViewMoreAccommodationsButton(partialEl, anchor)

    setTimeout(() => {
      HashManager.goToAnchor(anchor)
    }, 0)
    return
  }

  partialEl.addEventListener(
    PartialsLoadingEvents.HIDDEN,
    () => {
      clickViewMoreAccommodationsButton(partialEl, anchor)

      setTimeout(() => {
        HashManager.goToAnchor(anchor)
      }, 0)
    },
    { once: true }
  )
}

export default function (facets: Facets): void {
  scrollToAccommodation()
  events(facets, updatePartials)
  partialEvents(facets)
  recap()
  travelerSelector()
  budgetSlider('filter-offers', false)

  productCalendar(updatePartials)

  const calendar = ElementPropertiesManager.getProperty<SearchCalendarType>(document.getElementById('checkInDate') as HTMLInputElement, 'calendar')
  const capacityValue = HashManager.getParameter('capacity')
  const nightValue = HashManager.getParameter('night')
  const dateValue = HashManager.getParameter('checkInDate')

  if (dateValue) {
    setDate(dateValue, nightValue)
  }

  if (capacityValue) {
    setCapacity(capacityValue)
  }

  if (nightValue) {
    // we need to set the nights after the calendar is initialized as the calendar can init the nights field
    setNights(nightValue)
  }

  // don't update partials if all parameters are empty
  if (![dateValue, capacityValue, nightValue].every((value) => value === '')) {
    updatePartials()
  }

  window.addEventListener(
    'hashchange',
    () => {
      const hash = window.location.hash.match(/#/)
      if (!hash) {
        window.location.reload()
        return
      }

      HashManager.stopUpdatingHash()
      HashManager.parseHash()
      calendar?.setDate(HashManager.getParameter('checkInDate'))
      setNights(HashManager.getParameter('night'))
      setCapacity(HashManager.getParameter('capacity'))
      HashManager.startUpdatingHash()
    },
    false
  )
}
